// extracted by mini-css-extract-plugin
export default {"melodyRule":"AG-z"};